export default "__VITE_ASSET__DQPTcWeI__"